import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import { PrimaryButton } from "components/Button/style";
import { Col } from "react-bootstrap";

export const FormContainer = styled.div`
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.white};

  select {
    border-radius: 8px;
    height: 38px;
  }
`;

export const InputContainer = styled(Col)`
  display: grid;
`;

export const Button = styled(PrimaryButton)`
  width: 100px;
`;

export const ButtonsContainer = styled.div`
  position: relative;
  padding-top: 1.7rem;
  display: flex;
  justify-content: flex-start;
`;

export const DatePickerContainer = styled.div`
  display: grid;
  gap: 0.3rem;
  width: 100%;
`;

export const MaisFiltrosContainer = styled.div`
  width: 180px;
  position: relative;
  padding-top: 1.4rem;
  display: flex;
  justify-content: end;
`;

export const InputContainerMaisFiltros = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  display: grid;
  height: 60px;
`;
